import { Link } from 'react-router-dom';

interface CategoryCardProps {
  id: string;
  name: string;
  icon: string;
  description: string;
  image: string;
}

export default function CategoryCard({ id, name, icon, description, image }: CategoryCardProps) {
  return (
    <Link
      to={`/categories?tab=${id}`}
      className="group relative overflow-hidden rounded-lg cursor-pointer block"
    >
      <div className="relative h-48 md:h-56 w-full overflow-hidden">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent"></div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 p-4">
        <div className="flex items-center gap-2 mb-1">
          <div className="w-7 h-7 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full">
            <i className={`${icon} text-white text-sm`}></i>
          </div>
          <h3 className="text-white font-semibold text-base">{name}</h3>
        </div>
        <p className="text-white/80 text-xs line-clamp-2">{description}</p>
      </div>
    </Link>
  );
}